import { gql } from '@apollo/client';

export default gql`
  mutation SendConfirmationEmail($bookingReference: String!) {
    sendBookingConfirmationEmail(bookingReference: $bookingReference)
  }
`;
